// wordpressなので、jQueryは外部読み込みが簡単
//import "lightbox2/dist/css/lightbox.min.css";
import "./style.scss";

window.$ = require('jquery');
//window.lightbox = require('lightbox2');

//----------------------------------------------------------
// アンカースクロール
function scrollToAnchor(hash, $header) {
  let $target = $(hash);
  if ($target.length > 0) {
    let pos = $target.offset().top;
    pos -= $header.outerHeight();
    if (pos < 0) pos = 0;
    $('body, html').stop().animate({
      scrollTop: pos
    }, 500);
  }
}

//----------------------------------------------------------
$(() => {
  "use strict";
  // タッチデバイス判定
  let isTouchDevice = (window.ontouchstart === null);
  let language = $("html").attr("lang");
  if (isTouchDevice) {
    $("body").addClass("is_touchDevice");
  } else {
    $("body").addClass("is_notTouchDevice");
    $("head").append('<link rel="stylesheet" src="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Noto+Sans+JP:wght@400;500;700&display=swap">');
  }
  // ページ初期化
  let $ptb = $(".page-top-button");
  $ptb.fadeOut(0);
  // spハンバーガーメニュー処理
  let $sp_nav_opener = $(".menu-trigger");
  let $header = $("#globalNavBar");
  $sp_nav_opener.on("click", function () {
    if ($header.hasClass("active")) {
      $header.removeClass("active");
    } else {
      $header.addClass("active");
    }
  });
  // スクロールイベント
  $(document).on("scroll", function () {
    let st = $(window).scrollTop();
    if (st > 300) {
      $ptb.fadeIn();
    } else {
      $ptb.fadeOut();
    }
  });
  // ハッシュタグ付きリンクのスムーススクロール化
  $('a[href^="#"]').on("click", function () {
    let href = $(this).attr("href");
    let hash = href == "#" || href == "" ? "html" : href;
    scrollToAnchor(hash, $header);
    return false;
  });
  // ページロード時にハッシュがある場合は自動スクロール
  let urlHash = location.hash;
  if (urlHash) {
    $('body, html').stop().scrollTop(0);
    setTimeout(function () {
      scrollToAnchor(urlHash, $header);
    }, 100);
  }
  // Faqの処理
  $(".faq dd").slideUp(0);
  $(".faq dt").on("click", function () {
    $(this).next("dd").slideToggle();
  });
  // マイページの処理
  $(".wpuf-dashboard-navigation .dashboard a").attr("href", "/mypage/?section=inquiry-list").text("お問い合わせ一覧");
  $(".wpuf-dashboard-navigation ul li:first-child").on("click", (e) => {
    location.href = e.target.getAttribute("href");
  });
  $(".wpuf-dashboard-navigation .post a").attr("href", "/mypage/?section=order-list").text("コンテナ輸出");

  $(".wpuf-dashboard-content-alt").each(function () {
    $(".wpuf-dashboard-content").html($(this).html());
    $(this).remove();
  });

  // modal
	var open = $('.modal-open'),
		close = $('.modal-close'),
		container = $('.modal-container'),
    scrollTop;

	//開くボタンをクリックしたらモーダルを表示する
	open.on('click',() => {
    scrollTop = $(window).scrollTop();
    $('body').css({position: 'fixed', top:-scrollTop});
		container.addClass('active');
		return false;
	});

	//閉じるボタンをクリックしたらモーダルを閉じる
	close.on('click',() => {
    $('body').css({position:'', top:''});
    $(window).scrollTop(scrollTop);
		container.removeClass('active');
	});

	//モーダルの外側をクリックしたらモーダルを閉じる
  /*
	$(document).on('click', (e)=> {
		if(!$(e.target).closest('.modal-body').length) {
			close.trigger('click');
		}
	});
  */
});